export default "__VITE_ASSET__BTqszMR8__"